import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import classNames from "classnames";
import { Badge, Collapse } from "reactstrap";
import * as myConstClass from "../constant.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";
import routes from "../routes/index";
import "./logo.scss";
import { T, TF, Config } from "react-translator-component";

import "../locale/languages.js"; // sets Config.list / Config.default

const logo = myConstClass.SITE_URL + `img/Workzonebusiness.png`;

// ─── SidebarCategory ─────────────────────────────────────────────────────────

const SidebarCategory = withRouter(
  ({
    name,
    badgeColor,
    badgeText,
    icon,
    isOpen,
    children,
    onClick,
    location,
    to,
    firstChildPath,
    history,
  }) => {
    const isActive =
      location.pathname.indexOf(to) !== -1 || location.pathname === "/";

    const handleClick = () => {
      // Still toggle the accordion open/closed as before.
      onClick();
      // Previously the header only expanded the submenu and never
      // navigated anywhere, so clicking "Employee" (or any category with
      // children) while on an unrelated page like HR Agent left you
      // stranded there. Land on the section's first real page too —
      // firstChildPath is guaranteed to be a valid route since it's the
      // same path used for that child's own SidebarItem link.
      if (firstChildPath && location.pathname !== firstChildPath) {
        history.push(firstChildPath);
      }
    };

    return (
      <li className={"sidebar-item " + (isActive ? "active" : "")}>
        <span
          data-toggle="collapse"
          className={"sidebar-link " + (!isOpen ? "collapsed" : "")}
          onClick={handleClick}
          aria-expanded={isOpen ? "true" : "false"}
        >
          <FontAwesomeIcon
            icon={icon}
            fixedWidth
            className="align-middle mr-2"
          />{" "}
          <span className="align-middle">{name}</span>
          {badgeColor && badgeText ? (
            <Badge color={badgeColor} size={18} pill className="sidebar-badge">
              {badgeText}
            </Badge>
          ) : null}
        </span>
        <Collapse isOpen={isOpen}>
          <ul id="item" className="sidebar-dropdown list-unstyled">
            {children}
          </ul>
        </Collapse>
      </li>
    );
  },
);

// ─── SidebarItem ─────────────────────────────────────────────────────────────

const SidebarItem = withRouter(
  ({ name, badgeColor, badgeText, icon, location, to }) => (
    <li
      className={"sidebar-item " + (location.pathname === to ? "active" : "")}
    >
      <NavLink to={to} className="sidebar-link" activeClassName="active">
        {icon ? (
          <React.Fragment>
            <FontAwesomeIcon
              icon={icon}
              fixedWidth
              className="align-middle mr-2"
            />{" "}
            <span className="align-middle">{name}</span>
          </React.Fragment>
        ) : (
          name
        )}{" "}
        {badgeColor && badgeText ? (
          <Badge color={badgeColor} size={18} pill className="sidebar-badge">
            {badgeText}
          </Badge>
        ) : null}
      </NavLink>
    </li>
  ),
);

// ─── Route → keyword map for auto-open detection ──────────────────────────────

const ROUTE_KEYWORD_MAP = [
  { segment: "/guests", keywords: ["guests", "incident"] },
  {
    segment: "/employees",
    keywords: ["employee", "complaints", "admin_staff"],
  },
  {
    segment: "/settings",
    keywords: [
      "settingsorganization",
      "settingspayrollheaders",
      "settingsdepartment",
      "settingsholidays",
      "settingspoints",
      "settingssaroles",
      "settingsleave_type",
      "settingsadminapp",
      "settingsassets",
      "settingsallownce_type",
      "settingsallownce_code",
      "settingsnote_code",
      "settingsdocument_type",
      "settingsemployee_groups",
      "settingsblog_type",
      "settingsc_type",
      "settingsannoucement_type",
      "settingsnoticepaycheck",
      "settingspayrollPrivilege",
      "settingscategory_type",
      "settingscomplaint_type",
      "settings_groups",
      "settingscategory",
      "settingssubcategory",
      "settingsbank",
      "settingshrfields",
      "settingsactivitytype",
      "settingsactivitystatus",
      "settingsactivityevalution",
      "settingsattendansevalution",
      "settingsticketcategory",
    ],
  },
  {
    segment: "/payroll",
    keywords: ["tax_brackets", "payroll_line_entry", "payslip", "paycode"],
  },
  { segment: "/reports", keywords: ["reports"] },
  {
    segment: "/career",
    keywords: [
      "jobpost",
      "careers",
      "jobdisclouser",
      "job_descripation",
      "job_type",
      "job_title",
      "job_id",
    ],
  },
  {
    segment: "/shops",
    keywords: ["productcategory", "product", "order", "banner"],
  },
  { segment: "/course", keywords: ["course", "chaptors"] },
  { segment: "/groups", keywords: ["groups", "projectgroups"] },
  { segment: "/hradmin", keywords: ["hradmin"] },
  { segment: "/hrLetterListing", keywords: ["hrLetterListing"] },
  { segment: "/projects", keywords: ["projects", "projecttasks"] },
  {
    segment: "/shifts",
    keywords: ["shifts", "shift_schedular", "attendance", "absent", "leaves"],
  },
];

// ─── Sidebar ─────────────────────────────────────────────────────────────────

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { empData: [], user_id: "" };
    this.sidebarRef = React.createRef();
  }

  // ── Fetch profile data ──────────────────────────────────────────────────────

  fetchProfile() {
    const login_id = localStorage.getItem("login_id");
    const login_type = localStorage.getItem("login_type");
    const is_super_user = localStorage.getItem("is_super_user");

    let url;
    if (
      (login_type === "hr_admin" && is_super_user === "0") ||
      login_type === "super_admin"
    ) {
      url = myConstClass.BASE_URL + "user/getProfileInfo/" + login_id;
    } else if (login_type === "sub_admin" && is_super_user !== "0") {
      url =
        myConstClass.BASE_URL + "user/getSuperAdminStaffInfo/" + is_super_user;
    } else {
      url = myConstClass.BASE_URL + "user/getUserInfoE/" + login_id;
    }

    fetch(url)
      .then((r) => r.json())
      .then((response) => this.setState({ empData: response }))
      .catch((err) => console.log(err));
  }

  // ── Auto-open the active menu section & scroll it into view ─────────────────

  initOpenSections() {
    const pathName = this.props.location.pathname;
    const url = window.location.pathname;
    const str = url.split("/");
    const ten_path = "/" + str[1] + "/" + str[2];

    let didOpenSection = false;

    routes.forEach((route, index) => {
      // Translate route and child names
      route.name = T(route.name);
      if (route.children) {
        route.children.forEach((child) => {
          child.name = T(child.name);
        });
      }

      // For collapsible sections: open if current path matches a keyword
      if (route.children) {
        const entry = ROUTE_KEYWORD_MAP.find(
          (e) => route.path === ten_path + e.segment,
        );
        if (entry) {
          const matches = entry.keywords.some(
            (kw) => pathName.indexOf(kw) > -1,
          );
          if (matches) {
            didOpenSection = true;
            this.setState({ [index]: true });
          }
        }
      }
    });

    // After all state updates, scroll to the active item.
    // Use a longer delay when a section needed opening so the
    // Collapse animation has time to render child items into the DOM.
    const delay = didOpenSection ? 320 : 50;
    setTimeout(() => this.scrollToActiveItem(), delay);
  }

  // ── Scroll sidebar so the active <li> is visible ────────────────────────────
  //
  // Works for BOTH cases:
  //   - Top-level single items (e.g. "Business Promotions", "Dashboard")
  //   - Child items inside an open submenu (e.g. "Settings -> Organization")
  //
  // Uses offsetTop relative to the scrollable container for accurate positioning.

  scrollToActiveItem() {
    const sidebar = document.getElementById("vertical_scroll_sidebar");
    if (!sidebar) return;

    // Prefer active child inside an open dropdown first,
    // then fall back to any active top-level sidebar-item.
    const activeItem =
      sidebar.querySelector(
        ".sidebar-dropdown .sidebar-item.active a.active",
      ) ||
      sidebar.querySelector(".sidebar-dropdown .sidebar-item.active") ||
      sidebar.querySelector(".sidebar-nav > .sidebar-item.active");

    if (!activeItem) return;

    // Walk up the DOM to accumulate offsetTop relative to the scroll container
    let offsetTop = 0;
    let el = activeItem;
    while (el && el !== sidebar) {
      offsetTop += el.offsetTop || 0;
      el = el.offsetParent;
    }

    // For child items: scroll so the parent category header stays visible above
    // For top-level items: just bring item near the top with a small margin
    const isChild = !!activeItem.closest(".sidebar-dropdown");
    const scrollTarget = isChild
      ? Math.max(0, offsetTop - 48)
      : Math.max(0, offsetTop - 16);

    sidebar.scrollTo({ top: scrollTarget, behavior: "smooth" });
  }

  // ── Lifecycle ───────────────────────────────────────────────────────────────

  componentWillMount() {
    const pro_package = localStorage.getItem("package");
    this.state.pro_package = pro_package;
    this.updateLogo(pro_package);
    this.initOpenSections();
  }

  componentDidMount() {
    const pro_package = localStorage.getItem("package");
    this.state.pro_package = pro_package;
    this.updateLogo(pro_package);
    this.fetchProfile();
    // Re-run scroll after mount in case initOpenSections fired before DOM was ready
    setTimeout(() => this.scrollToActiveItem(), 400);
  }

  // ── Logo helper ─────────────────────────────────────────────────────────────

  updateLogo(pro_package) {
    const logoUrl = myConstClass.SITE_URL + `img/ChangeLogo1.jpg`;
    $("#pro_logo").attr("src", logoUrl);
  }

  // ── Toggle a menu section ───────────────────────────────────────────────────

  toggle = (index) => {
    const pro_package = localStorage.getItem("package");
    this.state.pro_package = pro_package;
    this.updateLogo(pro_package);
    this.fetchProfile();

    // Collapse all other open sections
    Object.keys(this.state).forEach(
      (item) => this.state[index] || this.setState(() => ({ [item]: false })),
    );

    // Toggle the clicked section, then scroll after collapse animation (~300ms)
    this.setState(
      (state) => ({ [index]: !state[index] }),
      () => {
        if (this.state[index]) {
          setTimeout(() => this.scrollToActiveItem(), 320);
        }
      },
    );
  };

  // ── Render ──────────────────────────────────────────────────────────────────

  render() {
    const { sidebar, pro_package } = this.props;
    const admin_id = localStorage.getItem("uname");
    const login_type = localStorage.getItem("login_type");
    const { empData } = this.state;

    // Profile image & name
    let profile_img, profile_name;
    if (empData && login_type === "hr_admin") {
      const hasImg = empData.image && empData.image !== "";
      profile_img = hasImg
        ? myConstClass.DOCS_URL +
          `uploads/profile_images_hr/${admin_id}/${empData.image}`
        : myConstClass.DOCS_URL + `img/profile.png`;
      profile_name = empData.first_name + " " + empData.last_name;
    } else if (empData && empData.first_name) {
      const hasImg = empData.profile_image && empData.profile_image !== "";
      profile_img = hasImg
        ? myConstClass.DOCS_URL +
          `/uploads/profile_img/${empData.profile_image}`
        : myConstClass.DOCS_URL + `img/profile.png`;
      profile_name = empData.first_name + " " + empData.last_name;
    } else {
      profile_img = myConstClass.DOCS_URL + `img/profile.png`;
      profile_name = "Name";
    }

    return (
      <nav
        className={classNames(
          "sidebar",
          sidebar.isOpen || "toggled",
          !sidebar.isOnRight || "sidebar-right",
        )}
      >
        <div className="sidebar-content">
          <div
            id="vertical_scroll_sidebar"
            style={{ overflowY: "scroll", scrollBehavior: "smooth" }}
          >
            <div>
              <div className="sidebar-user">
                <img
                  src={profile_img}
                  className="img-fluid rounded-circle mb-2"
                  alt={profile_name}
                />
                <div className="font-weight-bold">{profile_name}</div>
              </div>

              <ul className="sidebar-nav">
                {routes.map((category, index) => {
                  if (category.path === "x") return null;

                  const c_main = category.children ? (
                    <SidebarCategory
                      name={category.name}
                      badgeColor={category.badgeColor}
                      badgeText={category.badgeText}
                      icon={category.icon}
                      to={category.path}
                      firstChildPath={
                        category.children[0] && category.children[0].path
                      }
                      isOpen={this.state[index]}
                      onClick={() => this.toggle(index)}
                    >
                      {category.children.map((route, i) => (
                        <SidebarItem
                          key={i}
                          name={route.name}
                          to={route.path}
                          badgeColor={route.badgeColor}
                          badgeText={route.badgeText}
                        />
                      ))}
                    </SidebarCategory>
                  ) : (
                    <SidebarItem
                      name={category.name}
                      to={category.path}
                      icon={category.icon}
                      badgeColor={category.badgeColor}
                      badgeText={category.badgeText}
                    />
                  );

                  return (
                    <React.Fragment key={index}>
                      {category.header ? (
                        <li className="sidebar-header">{category.header}</li>
                      ) : null}
                      {c_main}
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
            <br />
          </div>
        </div>
      </nav>
    );
  }
}

export default withRouter(
  connect((store) => ({ sidebar: store.sidebar }))(Sidebar),
);